import {
  ReportTable,
  ReportTableData,
  ReportTableHeader,
} from '../../../components/Table/types';
import {
  useEmployeeLeadSourceReportsQuery,
  useLeadSourceSumReportQuery,
} from 'api';
import React from 'react';
import useLeadSourceHeaders from './useLeadSourceHeaders';
import employeeRangeOptions from 'helpers/employeeRangeOptions';

const sumValues = (values: number[]): number => {
  const total = values
    .filter(Boolean)
    .reduce((accumulator, currentValue) => accumulator + currentValue, null);
  return total;
};

const useTableData = (): ReportTable => {
  const headers: ReportTableHeader[] = useLeadSourceHeaders();
  const {data: {employeeLeadSourceReports = []} = {}} =
    useEmployeeLeadSourceReportsQuery({});
  const necessaryEmployeeReports = employeeLeadSourceReports.slice(1);
  const {data: {leadSourceSumReport = null} = {}} = useLeadSourceSumReportQuery(
    {},
  );
  const sumReportData = React.useMemo(() => {
    if (!leadSourceSumReport) {
      return;
    }
    return {
      label: leadSourceSumReport.name,
      values: [
        sumValues(leadSourceSumReport.values),
        ...leadSourceSumReport.values,
      ],
      callProps: {
        style: {
          borderBottom: 'double 3px var(--text-color-2)',
        },
      },
    };
  }, [leadSourceSumReport]);

  const reportData = React.useMemo(() => {
    return necessaryEmployeeReports.map((employeeReport) => {
      return {
        label: employeeRangeOptions.find(
          (employeeRangeOption) =>
            employeeRangeOption.value === employeeReport.name,
        )?.label,
        values: [sumValues(employeeReport.values), ...employeeReport.values],
      };
    });
  }, [necessaryEmployeeReports]);

  const data: ReportTableData[] = [sumReportData, ...reportData].filter(
    Boolean,
  );

  return {
    data,
    headers,
  };
};

export default useTableData;
